// removed by extract-text-webpack-plugin
module.exports = {"about":"index-module__about___jm6fe","hero":"index-module__hero___1rwRH","topic":"index-module__topic___1MATU","title":"index-module__title___2kPNm","heroImage":"index-module__heroImage___3gav7"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/pages/about-us/index.module.scss
// module id = 1890
// module chunks = 147